import { useEffect } from 'react';
import { insertInitialMetaForFrame } from '@comeon/analytics';
import { ANALYTICS_EVENT_CASINO, ANALYTICS_EVENT_LIVE_CASINO } from '@comeon/analytics/analytics-events';
import { selectCurrency } from '~/components/account/ducks/index';
import { selectAuthenticated } from '~/components/authentication/ducks/selectors';
import useCasinoLocation from '~/hooks/use-casino-location';
import { fetchCasinoGames } from '~/components/casino/ducks/index';
import {
	exploreCategoriesSelector as casinoExploreCategoriesSelector,
	exploreCasinoStatusSelector
} from '~/components/casino/ducks/selectors';
import { fetchLiveCasinoGames, fetchLiveCasinoData } from '~/components/live-casino/ducks/index';
import {
	exploreCategoriesSelector as liveCasinoExploreCategoriesSelector,
	exploreLiveCasinoStatusSelector
} from '~/components/live-casino/ducks/selectors';
import { fetchJackpotData, fetchLovedAndRecentGames } from '~/components/casino-shared/ducks/index';
import { useCasinoSharedDispatch, useCasinoSharedSelector } from '~/components/casino-shared/ducks/types';

const useExploreData = () => {
	const dispatch = useCasinoSharedDispatch();
	const authenticated = useCasinoSharedSelector(selectAuthenticated);
	const { isLiveCasinoLocation } = useCasinoLocation();
	const casinoExploreCategories = useCasinoSharedSelector(casinoExploreCategoriesSelector);
	const liveCasinoExploreCategories = useCasinoSharedSelector(liveCasinoExploreCategoriesSelector);
	const exploreCasinoStatus = useCasinoSharedSelector(exploreCasinoStatusSelector);
	const exploreLiveCasinoStatus = useCasinoSharedSelector(exploreLiveCasinoStatusSelector);
	const currency = useCasinoSharedSelector(selectCurrency);

	useEffect(() => {
		dispatch(fetchJackpotData());
		if (authenticated) {
			dispatch(fetchLovedAndRecentGames());
		}

		if (isLiveCasinoLocation) {
			insertInitialMetaForFrame(ANALYTICS_EVENT_LIVE_CASINO, dispatch);
			dispatch(fetchLiveCasinoGames());
		} else {
			insertInitialMetaForFrame(ANALYTICS_EVENT_CASINO, dispatch);
			dispatch(fetchCasinoGames());
		}
	}, [dispatch, authenticated, isLiveCasinoLocation]);

	useEffect(() => {
		dispatch(fetchLiveCasinoData(currency));
	}, [dispatch, currency, isLiveCasinoLocation]);

	return {
		exploreCategories: isLiveCasinoLocation ? liveCasinoExploreCategories : casinoExploreCategories,
		exploreCasinoStatus,
		exploreLiveCasinoStatus
	};
};

export default useExploreData;
